import React from 'react';
import { Button } from 'reactstrap';

const types = {
  1: "Images",
  2: "Floor Plans",
  3: "EPC",
  4: "Brochures"
};

export default class Asset extends React.Component {
  handleClick = () => this.props.downloadFile(this.props.asset.url, types[this.props.asset.type_id])

  render() {
    console.log(this.props);
    return (
      <div>
        <Button color="link" onClick={this.handleClick}>{types[this.props.asset.type_id]}</Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Asset.js